export function getUrlSearchParameters(currentUrlString) {
  const { searchParams } = new URL(currentUrlString);
  return Object.fromEntries(searchParams.entries());
}

export function getUrlWithoutSearchParameter(currentUrlString, searchParameterToExclude) {
  const url = new URL(currentUrlString);
  const oldSearchParamsEntries = Object.entries(url.searchParams);
  const newSearchParamEntries = oldSearchParamsEntries.filter(([paramName]) => paramName === searchParameterToExclude);

  if (newSearchParamEntries.length > 0) {
    const newSearchParamStrings = newSearchParamEntries.map(
      ([paramName, paramValue]) => `${encodeURIComponent(paramName)}=${encodeURIComponent(paramValue)}`,
    );
    url.search = `?${newSearchParamStrings.join('&')}`;
  } else {
    url.search = '';
  }
  return url.toString();
}
